import React , {Component } from 'react';
import AUX from '../../../hoc/Aux_';
import { Link } from 'react-router-dom';
import {fetchCms} from '../../../api/cms';
import Grid from '@material-ui/core/Grid';
import convert from 'htmr';


class Features extends Component{

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      searchText: '',
      cmsData:[],
      title: "",
      description: ""
    }
  }

  componentWillMount() {
    fetchCms("fitur")
    .then(response => {
        if (response != null) {
          this.setState({cmsData:response.data});
        }
      })
      .catch(error => {
      });

    fetchCms("fiturtitle")
    .then(response => {
        if (response != null) {
          response.data.map((e)=>{
            this.setState({title: e.title, description:e.description});
          })
        }
      })
      .catch(error => {
      });
  }

  renderFitur = (e)=>{
    return (

        <Grid xs={6} style = {{padding:10}}>
            <div className="features-box">
                <div className="features-icon">
                    <i className="mdi mdi-chart-bubble text-custom"></i>
                </div>
                <div className="features-desc">
                    <h5>{e.title}</h5>
                    <p className="pt-2" style={{textAlign:"justify"}}>{convert(e.description)} </p>
                </div>
            </div>
        </Grid>
    )
  }

    render(){
        return(
            <AUX>
            <section className="section" id="features">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-9 text-center">
                            <div className="title-icon">
                                <a href="https://jdih.big.go.id/lihatdoc?id=32748324" className="section-subtitle text-dark pt-3">Perpres No. 39 Tahun 2019 Tentang SATU DATA INDONESIA<i className="mdi mdi-arrow-right"></i></a>
                                <img src="images/satudata-padding.png" style={{width:350, height:250}} />
                            </div>
                            <h2 className="section-title pt-2">{this.state.title}</h2>
                            <p className="section-subtitle text-dark pt-3">{this.state.description} </p>
                        </div>
                    </div>
                    <Grid container spacing={4}>
                      {this.state.cmsData.map(this.renderFitur)}
                    </Grid>

                </div>
            </section>
        </AUX>
        );
    }
}

export default Features;

